import { render, staticRenderFns } from "./HistorialPaciente.vue?vue&type=template&id=addd9114&scoped=true&"
import script from "./HistorialPaciente.vue?vue&type=script&lang=js&"
export * from "./HistorialPaciente.vue?vue&type=script&lang=js&"
import style0 from "./HistorialPaciente.vue?vue&type=style&index=0&id=addd9114&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "addd9114",
  null
  
)

export default component.exports